import React from "react";
import { toast } from "react-toastify";
import strings from "../helpers/Localization";
import appSettings from "../AppSettings";
import { fetch } from "domain-task";
import { store } from "../boot-client";
import Error from "../components/Error";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, info) {
        // console.log("error caught");
        // console.log(error.message);
        // console.log(error.stack);
        // console.log(info);

        toast.error(strings.errorDevNotified);

        this.setState({
            hasError: true
        });

        const localStorageObj = Object.assign({}, localStorage);
        // Duplicate navigator object to be able to serialize it
        const _navigator = {};
        for (const i in navigator) {_navigator[i] = navigator[i];}

        const obj = {
            exception: error.stack,
            body: JSON.stringify(info),
            localStorage: JSON.stringify(localStorageObj),
            navigator: JSON.stringify(_navigator),
            source: "ErrorBoundary | componentDidCatch"
        };

        console.error(obj);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <Error />;
        }
        return this.props.children;
    }
}
